/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-11 09:19:19
 * @LastEditors: susj
 * @LastEditTime: 2020-11-28 14:54:01
 */
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/core';

import './assets/icons';
import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);

// import '@/mock';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
